module.exports = __webpack_public_path__ + "static/media/union.0f9c467a.svg";